<div class="dropdown-container w-100">
    <div class="dropdown-selected d-flex p-1" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()" [ngStyle]="config?.styles">
      <div *ngIf="selectedOption?.icon || config?.placeholderIcon" class="v-center mx-1">
        @if(selectedOption?.icon && config?.iconType === 'assetImage') {
          <img class="dropdown-img" [ngStyle]="customStyle.image" [src]="selectedOption.icon | assetUrl" alt="">
        } @else {
          <mat-icon class="select-icon">
            {{ selectedOption?.icon || config?.placeholderIcon }}
          </mat-icon> 
        }
        
      </div>
      <div class="v-center flex-grow-1">
        <span class="field-text">
          {{ selectedOption ? selectedOption.label : ( config?.placeholderText ? config?.placeholderText : 'Select an item' ) }}
        </span>
      </div>
      <div class="v-center">
        <mat-icon class="select-icon-drop"> keyboard_arrow_down </mat-icon>
      </div>
    </div>
  
    <div class="dropdown-menu w-100" *ngIf="dropdownOpen">
      <div *ngFor="let field of fields" class="dropdown-section">
        <h4 *ngIf="field.label" class="section-title ">{{ field.label }}</h4>
        <div *ngFor="let option of field.options" class="dropdown-item" [ngClass]="{ 'active-option': selectedValue && selectedValue === option.value }" (click)="selectOption(option)" (keydown)="selectOption(option)">
          @if(config?.iconType === 'assetImage') {
            <img class="dropdown-img" [ngStyle]="customStyle.image" [src]="option.icon | assetUrl" alt="">
          } @else {
            <mat-icon>{{ option.icon }}</mat-icon>
          }
          <span class="ellipsis">{{ option.label }}</span>
        </div>
      </div>  
  </div>